import React, { useMemo } from 'react';
import { Button, NumberField, StyledWrapper, TextField } from 'ui-toolkit';
import { Form, Formik } from 'formik';
import { DateRangeFilter } from 'ui-toolkit/components/DataGrid/DateRangeFilter';
import { StyledTableRow } from './MatchedActualStyles';
import { IEscrowActualIncomingAchQuery } from 'types/accounting/query/IEscrowActualIncomingAchQuery';

interface IMatchActualACHDepositSearchBarProps {
  setQuery: (query: IEscrowActualIncomingAchQuery) => void;
  query: IEscrowActualIncomingAchQuery;
}
export const MatchActualACHDepositSearchBar: React.FC<IMatchActualACHDepositSearchBarProps> = ({ setQuery, query }) => {
  const initialValues = useMemo(() => {
    return {
      createdAt: query.createdAt,
      wellsFargoTransactionNumber: query.wellsFargoTransactionNumber,
      source: query.source,
      amountCents: query.amountCents,
    };
  }, [query]);

  const onSubmit = (values: any) =>
    setQuery({
      ...query,
      createdAt: values.createdAt ?? undefined,
      wellsFargoTransactionNumber: values.wellsFargoTransactionNumber ?? undefined,
      source: values.source ?? undefined,
      amountCents: values.amountCents ?? undefined,
    });

  const updateDateRange = (newDate: any, setFieldValue: any) => {
    setFieldValue('createdAt', newDate);
  };

  return (
    <StyledWrapper>
      <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
        {({ handleSubmit, values, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <StyledTableRow columnsLength={5}>
              <DateRangeFilter
                defaultValue={values.createdAt}
                onFilter={(value) => updateDateRange(value, setFieldValue)}
                showClear
                fixed
              />
              <TextField name={`wellsFargoTransactionNumber`} placeholder={'Memo'} />
              <TextField name={`source`} placeholder={'Sender'} />
              <NumberField name={`amountCents`} mode="currency" placeholder="Received" valueIsCents />
              <Button intent={'primary'} type={'submit'} data-test-id={`search-button`}>
                Search
              </Button>
            </StyledTableRow>
          </Form>
        )}
      </Formik>
    </StyledWrapper>
  );
};
